function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var DiplomacyProposeTemplate = require('./diplomacy-propose.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var DiplomacyProposeOverlay = /*#__PURE__*/function () {
  function DiplomacyProposeOverlay(app, mod) {
    _classCallCheck(this, DiplomacyProposeOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod, false);
    this.overlay.clickBackdropToClose = false;
    this.faction = '';
    this.proposals = [];
    this.proposal = {};
    this.proposal.confirms = [];
    this.proposal.terms = [];
    this.proposal.parties = [];
    this.proposal.proposer = '';
    this.game_menu_zindex = 0;
  }
  return _createClass(DiplomacyProposeOverlay, [{
    key: "purgeProposals",
    value: function purgeProposals() {
      this.proposals = [];
      this.proposal = {};
      this.proposal.confirms = [];
      this.proposal.terms = [];
      this.proposal.parties = [];
      this.proposal.proposer = '';
    }
  }, {
    key: "updateInstructions",
    value: function updateInstructions() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      try {
        document.querySelector('.diplomacy-propose-overlay .help').innerHTML = msg;
      } catch (err) {}
    }
  }, {
    key: "showSubMenu",
    value: function showSubMenu() {
      document.querySelectorAll('.mainmenu').forEach(function (el) {
        el.style.display = 'none';
      });
      document.querySelectorAll('.submenu').forEach(function (el) {
        el.style.display = 'block';
      });
    }
  }, {
    key: "showMainMenu",
    value: function showMainMenu() {
      document.querySelectorAll('.mainmenu').forEach(function (el) {
        el.style.display = 'block';
      });
      document.querySelectorAll('.submenu').forEach(function (el) {
        el.style.display = 'none';
      });
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "hide",
    value: function hide() {
      this.purgeProposals();
      this.overlay.hide();
      var gm = document.querySelector('#saito-header');
      if (gm) {
        gm.style.zIndex = this.game_menu_zindex;
      }
      return;
    }
  }, {
    key: "render",
    value: function render() {
      var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var gm = document.querySelector('#saito-header');
      if (gm) {
        this.game_menu_zindex = gm.style.zIndex;
        gm.style.zIndex = 999;
      }
      var his_self = this.mod;
      var num = 0;
      if (faction == '') {
        faction = this.faction;
      } else {
        this.faction = faction;
      }
      if (faction != '' && !this.proposal.parties.includes(faction)) {
        this.proposal.parties.push(faction);
      }
      this.overlay.show(DiplomacyProposeTemplate(this));
      this.renderAllProposals(faction);
      this.pushHudUnderOverlay();
      this.overlay.show();
      //document.querySelector(".diplomacy-propose-overlay").style.visibility = "visible";
      //document.querySelector(".diplomacy-propose-overlay .buttons").style.visibility = "visible";
      //document.querySelector(".diplomacy-propose-overlay").style.display = "block";

      this.showMainMenu();
      this.attachEvents(faction);
    }
  }, {
    key: "renderAddProposalMenu",
    value: function renderAddProposalMenu(faction) {
      var _this = this;
      var his_self = this.mod;
      var menu = this.mod.returnDiplomacyMenuOptions(this.mod.game.player, faction);
      document.querySelector('.diplomacy-propose-overlay').style.backgroundImage = '';
      document.querySelector('.diplomacy-propose-overlay .buttons').style.visibility = 'hidden';
      var html = '';
      for (var i = 0; i < menu.length; i++) {
        if (menu[i].check(his_self, his_self.game.player, faction)) {
          html += this.returnMenuHTML(menu[i].name, menu[i].img, i);
        }
      }
      document.querySelector('.diplomacy-propose-overlay .menu').innerHTML = html;
      for (var _i = 0; _i < menu.length; _i++) {
        var obj = document.querySelector(".menu-option-container".concat(_i));
        if (obj) {
          obj.onclick = function (e) {
            // remove click event from all
            _this.overlay.hide();
            _this.pullHudOverOverlay();
            var id = e.currentTarget.id;
            menu[id].fnct(his_self, faction, function (terms) {
              for (var z = 0; z < terms.length; z++) {
                var io = _this.mod.returnDiplomacyImpulseOrder(faction);
                for (var y = 0; y < io.length; y++) {
                  if (terms[z].indexOf(io[y]) > -1 && !_this.proposal.parties.includes(io[y])) {
                    _this.proposal.parties.push(io[y]);
                  }
                  if (terms[z].indexOf('marital') > -1 && !_this.proposal.parties.includes('papacy') && io[y] == 'papacy') {
                    _this.proposal.parties.push('papacy');
                  }
                  if (terms[z].indexOf('marriage') > -1 && !_this.proposal.parties.includes('papacy') && io[y] == 'papacy') {
                    _this.proposal.parties.push('papacy');
                  }
                }
                _this.proposal.terms.push(terms[z]);
              }
              _this.render(faction);
              _this.renderCurrentProposal();
            });
          };
        }
      }
    }
  }, {
    key: "renderAllProposals",
    value: function renderAllProposals() {
      var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var any_proposals = false;
      var proposals_html = '<ol>';
      for (var i = 0; i < this.proposals.length; i++) {
        any_proposals = true;
        proposals_html += '<li><ul>';
        var p = this.proposals[i];
        var t = this.mod.convertTermsToText(p.terms);
        for (var z = 0; z < t.length; z++) {
          proposals_html += '<li>' + t[z] + '</li>';
        }
        proposals_html += '</ul></li>';
      }
      proposals_html += '</ol>';
      if (any_proposals) {
        this.updateInstructions("".concat(this.mod.returnFactionName(faction), " - Diplomacy Stage - All Proposals"));
        document.querySelector('.diplomacy-propose-overlay .content').innerHTML = proposals_html;
        try {
          document.querySelector('.mainmenu.add').innerHTML = 'create new proposal';
          document.querySelector('.mainmenu.end').innerHTML = 'submit and see if they accept';
        } catch (err) {
          console.log(JSON.stringify(err));
        }
      } else {
        this.updateInstructions("".concat(this.mod.returnFactionName(faction), " - Diplomacy Stage"));
        document.querySelector('.content').innerHTML = 'propose a diplomatic agreement?';
      }
    }
  }, {
    key: "renderCurrentProposal",
    value: function renderCurrentProposal() {
      var proposals_html = '<ul>';
      var t = this.mod.convertTermsToText(this.proposal.terms);
      var any_proposals = false;
      for (var z = 0; z < t.length; z++) {
        any_proposals = true;
        proposals_html += '<li>' + t[z] + '</li>';
      }
      proposals_html += '</ul>';
      this.updateInstructions('Creating New Proposal');
      if (any_proposals) {
        document.querySelector('.diplomacy-propose-overlay .help').innerHTML = 'your proposal consists of the following:';
        document.querySelector('.diplomacy-propose-overlay .content').innerHTML = proposals_html;
        document.querySelector('.diplomacy-propose-overlay .content').style.display = 'block';
      } else {
        document.querySelector('.diplomacy-propose-overlay .help').innerHTML = 'add term to your new proposal';
        document.querySelector('.content').style.display = 'none';
      }
      this.showSubMenu();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      //
      // finish diplomacy stage
      //
      document.querySelector('.end').onclick = function (e) {
        for (var z = 0; z < _this2.proposals.length; z++) {
          _this2.mod.addMove('diplomacy_submit_proposal\t' + JSON.stringify(_this2.proposals[z]));
        }
        _this2.mod.endTurn();
        _this2.hide();
      };

      //
      // start new proposal
      //
      document.querySelector('.add').onclick = function (e) {
        document.querySelector('.diplomacy-propose-overlay .buttons').style.visibility = 'hidden';
        document.querySelector('.content').innerHTML = '';
        _this2.terms = [];
        _this2.renderAddProposalMenu(faction);
        _this2.renderCurrentProposal();
      };

      //
      // add condition to proposal
      //
      document.querySelector('.also').onclick = function (e) {
        _this2.renderCurrentProposal();
        _this2.renderAddProposalMenu(faction);
      };

      //
      // submit
      //
      document.querySelector('.finish').onclick = function (e) {
        _this2.proposal.proposer = _this2.faction;
        _this2.proposals.push(_this2.proposal);
        _this2.proposal = {};
        _this2.proposal.terms = [];
        _this2.proposal.parties = [];
        _this2.proposal.proposer = _this2.faction;
        _this2.render(faction);
        _this2.showMainMenu();
        _this2.renderAllProposals(faction);
      };

      //
      // delete
      //
      document.querySelector('.delete').onclick = function (e) {
        _this2.proposal = {};
        _this2.proposal.terms = [];
        _this2.proposal.parties = [];
        _this2.proposal.proposer = _this2.faction;
        _this2.render(faction);
        _this2.showMainMenu();
        _this2.renderAllProposals(faction);
      };
      return;
    }
  }, {
    key: "returnMenuHTML",
    value: function returnMenuHTML() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var img = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var idx = arguments.length > 2 ? arguments[2] : undefined;
      var active_option = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'active card';
      return "\n              <div id=\"".concat(idx, "\" class=\"menu-option-container").concat(idx, " menu-option-container ").concat(active_option, "\">\n                <div class=\"menu-option-image\">\n                  <img src=\"/his/img/backgrounds/diplomacy/").concat(img, "\" />\n                </div>\n                <div class=\"menu-option-title\">").concat(name, "</div>\n              </div>\n          ");
    }
  }]);
}();
module.exports = DiplomacyProposeOverlay;